import React from "react";
import ReactDOM from "react-dom";
import poly from "poly-js-utils";
import css from "./common/dynamic-css-loader.js";
import EventsPage from "./components/events_page";

poly.KalturaHelpers.init();
css.loadDynamicCss();

ReactDOM.render(<EventsPage/>, document.getElementById('events'));



// WEBPACK FOOTER //
// ./events.js